import data from "../../../pages/Pages/Report/data/data";
import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ReportCommentServices = {
  getList: async (data) => {
    const response = await apiService.get(`/reportcomment`);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post(`/reportcomment`, data);
    return response.data;
  },
  getById: async (id) => {
    const response = await apiService.get(`/reportcomment/by-report/${id}`);
    return response.data;
  },
  update: async (id, data) => {
    const response = await apiService.put(`/reportcomment/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/reportcomment/${id}`);
    return response.data;
  },
};

export default ReportCommentServices;
